exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".trigger,\n.logout .anticon {\n  font-size: 18px;\n  line-height: 64px;\n  padding: 0 24px;\n  cursor: pointer;\n  -webkit-transition: color .3s;\n  -o-transition: color .3s;\n  transition: color .3s; }\n\n.trigger:hover {\n  color: #1890ff; }\n\n.logo {\n  height: 32px;\n  margin: 16px; }\n\n.field-logo {\n  background-color: #092d60;\n  width: 100%;\n  height: 90px;\n  margin-top: -20px;\n  padding-top: 20px; }\n\n.main-layout {\n  margin-left: 200px; }\n\n.logout {\n  float: right; }\n  .logout .anticon {\n    padding-left: 10px; }\n\n.ant-menu-item-selected, .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {\n  background-color: #e69835 !important;\n  margin-left: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/main/main.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/main/main.css
// module chunks = 0